import { render, staticRenderFns } from "./AssignTemplates.vue?vue&type=template&id=2ebdbf14&scoped=true&"
import script from "./AssignTemplates.vue?vue&type=script&lang=js&"
export * from "./AssignTemplates.vue?vue&type=script&lang=js&"
import style0 from "./AssignTemplates.vue?vue&type=style&index=0&id=2ebdbf14&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ebdbf14",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VDataTable,VSelect,VToolbar,VToolbarTitle})
